import { render, staticRenderFns } from "./PerformerMemberItem.vue?vue&type=template&id=2c787fdf&scoped=true&"
import script from "./PerformerMemberItem.vue?vue&type=script&lang=js&"
export * from "./PerformerMemberItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformerMemberItem.vue?vue&type=style&index=0&id=2c787fdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c787fdf",
  null
  
)

export default component.exports